module.exports = __webpack_public_path__ + "img/slide-5.7d03d339.webp";